import { render, staticRenderFns } from "./AuthPasswordLayout.vue?vue&type=template&id=5f80e5d8&scoped=true"
import script from "./AuthPasswordLayout.vue?vue&type=script&lang=js"
export * from "./AuthPasswordLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthPasswordLayout.vue?vue&type=style&index=0&id=5f80e5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80e5d8",
  null
  
)

export default component.exports